import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "color", "swatchSize", "option"];
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import ColorSwatch from './ColorSwatch';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ItemComponent = _ref => {
  let {
      as,
      color,
      swatchSize,
      option: {
        text,
        value: theme
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: "unstyled"
  }, rest, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexGrow: 1,
      rowGap: "200",
      children: [/*#__PURE__*/_jsx(ColorSwatch, {
        theme: theme,
        size: swatchSize
      }), /*#__PURE__*/_jsx(Text, {
        as: as,
        color: color,
        marginInlineStart: "200",
        children: text
      })]
    })
  }));
};
export const ValueComponent = props => /*#__PURE__*/_jsx(ItemComponent, Object.assign({
  as: "h6",
  color: "fill-secondary-default",
  swatchSize: 15
}, props));
export const OptionComponent = props => /*#__PURE__*/_jsx(ItemComponent, Object.assign({}, props));